import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const baseUrl = process.env.REACT_APP_API_HOST;

// The response interceptor already unwraps to the body, so `.data` here is
// the payload's data field.

export const getVendors = async () => {
  const response = await axios.get(`${baseUrl}/${apiConstants.QUOTE_VENDORS}`);
  return response.data;
};

export const getVendorThread = async (vendorId) => {
  const response = await axios.get(`${baseUrl}/${apiConstants.QUOTE_VENDORS}/${vendorId}/thread`);
  return response.data;
};

export const markVendorRead = async (vendorId) => {
  const response = await axios.post(`${baseUrl}/${apiConstants.QUOTE_VENDORS}/${vendorId}/read`, {});
  return response.data;
};

export const replyToVendor = async (vendorId, text) => {
  const response = await axios.post(`${baseUrl}/${apiConstants.QUOTE_VENDORS}/${vendorId}/reply`, { text });
  return response.data;
};

export const approveRequisition = async (id, messageText) => {
  const response = await axios.post(`${baseUrl}/${apiConstants.QUOTE_REQUISITIONS}/${id}/approve`, messageText ? { messageText } : {});
  return response.data;
};

export const cancelRequisition = async (id) => {
  const response = await axios.post(`${baseUrl}/${apiConstants.QUOTE_REQUISITIONS}/${id}/cancel`, {});
  return response.data;
};

export const confirmVendorRates = async (intakeId, payload) => {
  const response = await axios.post(`${baseUrl}/${apiConstants.QUOTE_VENDOR_RATES}/${intakeId}/confirm`, payload);
  return response.data;
};

export const rejectVendorRates = async (intakeId, reason) => {
  const response = await axios.post(`${baseUrl}/${apiConstants.QUOTE_VENDOR_RATES}/${intakeId}/reject`, { reason });
  return response.data;
};
